import React, { useReducer, useState } from 'react';
import { initialState, AuthReducer } from './reducer';
import moment from 'moment';

const AuthStateContext = React.createContext();
const AuthDispatchContext = React.createContext();

export function useAuthState() {
	const context = React.useContext(AuthStateContext);
	if (context === undefined) {
		throw new Error('useAuthState must be used within a AuthProvider');
	}

	return context;
}

export function useAuthDispatch() {
	const context = React.useContext(AuthDispatchContext);
	if (context === undefined) {
		throw new Error('useAuthDispatch must be used within a AuthProvider');
	}

	return context;
}

export const AuthProvider = ({ children }) => {
	const [user, dispatch] = useReducer(AuthReducer, initialState,);
	const [HeaderYear, setHeaderYear] = useState('0')

	const CurrentYear = moment().format('YYYY')

	const CurrentMonth = moment().format('M')

	const [year, setYear] = useState({
		DDL: [],
		ID: 0,
		Label: "Select .....",
	})
	const [Month, setMonth] = useState({
		DDL: [],
		ID: 0,
		Label: "Select .....",
	})
	const [Ward, setWard] = useState({
		DDL: [],
		ID: 0,
		Label: "Select .....",
	})

	return (
		// <AuthStateContext.Provider value={user}>
		<AuthStateContext.Provider value={{ user, year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth }}>
			<AuthDispatchContext.Provider value={dispatch}>
				{children}
			</AuthDispatchContext.Provider>
		</AuthStateContext.Provider >
	);
};
